/** How the subjects may stand against the sheet. The values are the form ids. */
export const enum FillFlip {
  /** Both ways round, and the leftover strip filled with turned subjects. */
  FLIP_EFFICIENT = "on",
  /** Both ways round, never mixed. */
  FLIP_SAME_ORIENTATION = "off",
  /** Only the way they come, one grid. */
  FLIP_AS_IS = "same",
  /** Only turned, one grid. */
  FLIP_ROTATED = "rot",
}
